import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { SvgIcon } from '../../../components'
import { concatClasses } from '../../../utils/fns'

const CompanyLogo = (props) => {
  return (
    <a
      className={concatClasses('sstLogoLink', props.className)}
      style={props.disabled ? { pointerEvents: 'none', cursor: 'none' } : {}}
      href="https://www.strongtie.com/"
    >
      <SvgIcon id="sstLogo" src="assets/images/sst-logo-revised-noborder.svg" />
    </a>
  )
}

CompanyLogo.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

CompanyLogo.defaultProps = {
  disabled: false,
  className: '',
}

export default memo(CompanyLogo)
